import React from 'react';
import { Carousel, useCarousel } from '@yme/atoms/carousel';
import { Col, Container, FlexibleCol, GridWrapper, Row } from '@yme/atoms/grid';
import { useWindowSize } from '@yme/hooks/useWindowSize';
import { ForOwnersCard } from '@yme/molecules/cards';
import { colorCoreBlack900Base } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { HeadingLevel2 } from '@yme/tokens/typography';
import { getCardsColumnNumberForDesktop } from '@yme/utils/common';
import { AspectRatio } from '@yme/utils/constants';
import { CARD_ITEM_SETTINGS, FOR_OWNERS_MAX_CARD, GAP_BETWEEN_ITEMS } from './constants';
import { getKey } from './helpers';
export function ForOwners(props) {
    const { data, title, isRightToLeft = false, indentSettings = GAP_BETWEEN_ITEMS, cardItemSettings = CARD_ITEM_SETTINGS, } = props;
    const { isMobileView } = useWindowSize();
    const { activeItem, onClickPrevItem, onClickNextItem, counts, setCounts } = useCarousel();
    if (isMobileView) {
        return (React.createElement(GridWrapper, null,
            React.createElement(FlexWrapper, { isRightToLeft: isRightToLeft, flexDirection: "column" },
                title && (React.createElement(FlexWrapper, { alignSelf: "start", mb: "24px", mbTablet: "24px", mbDesktop: "32px" },
                    React.createElement(HeadingLevel2, { color: colorCoreBlack900Base }, title))),
                React.createElement(Carousel
                // common props for functionality of carousel
                , { 
                    // common props for functionality of carousel
                    counts: counts, isRightToLeft: isRightToLeft, activeItem: activeItem, onClickPrevItem: onClickPrevItem, onClickNextItem: onClickNextItem, 
                    // configurable props
                    getterSize: indentSettings, items: data, ChildComponent: ForOwnersCard, setCounts: setCounts, carouselConfig: cardItemSettings, isDotsPanelVisible: true, dataTestId: "for-owners" }))));
    }
    return (React.createElement(Container, null,
        React.createElement(Row, null,
            React.createElement(Col, null,
                React.createElement(FlexWrapper, { alignSelf: "start", mb: "24px", mbTablet: "24px", mbDesktop: "32px" },
                    React.createElement(HeadingLevel2, { color: colorCoreBlack900Base }, title)))),
        React.createElement(Row, null, data.map((item, index, cards) => (React.createElement(FlexibleCol, { key: getKey(item.title, index), lg: getCardsColumnNumberForDesktop(cards.length, FOR_OWNERS_MAX_CARD), md: getCardsColumnNumberForDesktop(cards.length, FOR_OWNERS_MAX_CARD) },
            React.createElement(ForOwnersCard, { cardProps: {
                    image: item.image,
                    title: item.title.trim(),
                    description: item?.description?.trim(),
                    link: item.link,
                    labelLink: item.labelLink,
                    countLineVisible: item.countLineVisible,
                    isEllipsisEndingLine: false,
                    aspectRatio: cards.length === 1 ? AspectRatio.RectangleLevel2 : AspectRatio.RectangleLevel3,
                }, isRightToLeft: isRightToLeft })))))));
}
ForOwners.displayName = 'ForOwners_organism';
